import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import ExternalVerificationRepository from '@/repositories/ExternalVerificationRepository';
import { CheckVOB, ExternalVerification } from '@/types/externalVerification';

export const useInsuranceVOB = (
  options?: MutationOptions<ExternalVerification, AxiosError, { policyId: string; data?: CheckVOB }>
) => {
  const externalVerificationRepository = ExternalVerificationRepository();
  return useMutation({
    mutationFn: ({ policyId, data }: { policyId: string; data?: CheckVOB }) =>
      externalVerificationRepository.insuranceVOB({ policyId, data }),
    ...options
  });
};

export default useInsuranceVOB;
